import React, { useState, useRef, useEffect } from "react";
import { CSSTransition } from "react-transition-group";

import "../Backgrounds.css";
import "./ProjectPage.css";
import "../App.css";
import VideoBackground from "./ProjectPageVideoBackground";
import MainHeader from "./MainHeader";
import AudioPlayer from "./audioPlayer/AudioPlayer";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const ProjectPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // --- NEW LOGIC START ---
  const [activeVideoUrl, setActiveVideoUrl] = useState(props.videoUrl);
  const [videoMounted, setVideoMounted] = useState(true);
  const nodeRef = useRef(null);

  useEffect(() => {
    setActiveVideoUrl(props.videoUrl);
    setVideoMounted(true);
  }, [props.videoUrl]);

  const handleTrackChange = (newTrackDetails) => {
    if (
      newTrackDetails.videoUrl &&
      newTrackDetails.videoUrl !== activeVideoUrl
    ) {
      setVideoMounted(false);
      setTimeout(() => {
        setActiveVideoUrl(newTrackDetails.videoUrl);
      }, 300);
      setTimeout(() => {
        setVideoMounted(true);
      }, 305);
    }
  };
  // --- NEW LOGIC END ---

  // Destructure props with Default Values for the button
  const {
    image1Url,
    image2Url,
    image3Url,
    audioPlayerPath,
    directedBy,
    projectTitle,
    projectPara1,
    projectPara2,
    projectPara3,
    multitrack,
    trackArray,
    // NEW: Default to Home ('/') and standard text if not provided in JSON
    backLinkPath = "/",
    backLinkText = "BACK TO MAIN PORTFOLIO",
  } = props;

  return (
    <div className="projectsBackground">
      <MainHeader />

      <div className="portfolioBackground"></div>

      <div className="projectGridContainer">
        <div className="projectGrid">
          <div className="mainBodyContainer">
            <div className="solidLine"> _ </div>
            <div className="projectTitle"> {projectTitle}</div>
          </div>

          <div className="imagePlayerCombiFrame">
            <div className="videoFrame">
              <CSSTransition
                nodeRef={nodeRef}
                in={videoMounted}
                timeout={500}
                classNames="my-node"
                unmountOnExit
              >
                <div ref={nodeRef} style={{ width: "100%", height: "100%" }}>
                  <VideoBackground videoUrl={activeVideoUrl} />
                </div>
              </CSSTransition>
            </div>

            <div className="playerFrame">
              <div className="player">
                <AudioPlayer
                  multiTrack={multitrack}
                  trackArray={trackArray}
                  folderPath={audioPlayerPath}
                  onTrackChange={handleTrackChange}
                />
              </div>
            </div>
          </div>

          <div className="mainBodyContainer">
            <div className="projectTitleWrapper">
              <div className="navTitle"> {projectTitle} </div>
            </div>

            <div className="directedBy"> {directedBy} </div>

            <div className="projectText"> {projectPara1} </div>
            <div className="projectText"> {projectPara2} </div>
            <div className="projectText"> {projectPara3} </div>

            <div className="supplementaryImageContainer">
              <div className="frame">
                <img
                  src={image2Url}
                  className="projectImage"
                  alt="project view 2"
                />
              </div>
              <div className="frame">
                <img
                  src={image3Url}
                  className="projectImage"
                  alt="project view 3"
                />
              </div>
            </div>

            {/* UPDATED NAVIGATION BUTTONS */}
            <div className="navigationButtons">
              <div className="centreButtonWrapper">
                <Link to={backLinkPath}>
                  <button className="button4">{backLinkText}</button>
                </Link>
              </div>
            </div>

            <div className="solidLine"> _ </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
export default ProjectPage;
